import type { FC } from "react";

import { Telephone as UITelephone } from "@jti/ui/components/Telephone/Telephone";

import type { telephoneInputs } from "./Telephone.builder";

export type TelephoneBuilderProps = BuilderComponentProps<typeof telephoneInputs>;

export const Telephone: FC<TelephoneBuilderProps> = ({
  isRequired,
  isDisabled,
  showLabel,
  isInfoMessageVisible,
  isWithoutDropdown,
  placeholder,
  disclaimer,
  id,
  mode,
  label,
  isLocked,
}) => {
  return (
    <UITelephone
      id={id}
      isRequired={isRequired}
      isDisabled={isDisabled}
      showLabel={showLabel}
      isInfoMessageVisible={isInfoMessageVisible}
      isWithoutDropdown={isWithoutDropdown}
      placeholder={placeholder}
      disclaimer={disclaimer}
      fieldName={() => id || "internationalPhone"}
      mode={mode}
      label={label}
      isLocked={isLocked}
    />
  );
};
